import {
	SET_ICEPACK_STATE_INFO,
	SET_IS_ICEPACK_STATE_INFO_LOADING,
	SET_IS_ICEPACK_STATE_CREATING,
	SET_IS_ICEPACK_STATE_UPDATING,
	SET_IS_ICEPACK_STATE_DELETING,
	RESET_STATE,
} from './actions';

export const initialState = {
	icepackStateInfo: null,
	isIcepackStateInfoLoading: false,
	isIcepackStateCreating: false,
	isIcepackStateUpdating: false,
	isIcepackStateDeleting: false,
};

const icepackStateModalReducer = (state = initialState, action) => {
	const { type, payload } = action;
	switch (type) {
		case SET_ICEPACK_STATE_INFO:
			return {
				...state,
				icepackStateInfo: payload,
			};
		case SET_IS_ICEPACK_STATE_INFO_LOADING:
			return {
				...state,
				isIcepackStateInfoLoading: payload,
			};
		case SET_IS_ICEPACK_STATE_CREATING:
			return {
				...state,
				isIcepackStateCreating: payload,
			};
		case SET_IS_ICEPACK_STATE_UPDATING:
			return {
				...state,
				isIcepackStateUpdating: payload,
			};
		case SET_IS_ICEPACK_STATE_DELETING:
			return {
				...state,
				isIcepackStateDeleting: payload,
			};
		case RESET_STATE:
			return initialState;
		default:
			return state;
	}
};

export default icepackStateModalReducer;
